// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

/* Override body overflow when login page is shown */
body.login-page-active {
  overflow: auto !important;
}

.login-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
  padding: 40px;
  margin: 40px auto;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.dbs-logo {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
}

.login-header h1 {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.login-subtitle {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.form-group input,
.form-group select {
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.2s;
  background: white;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #F01714;
}

.form-group input.error,
.form-group select.error {
  border-color: #e74c3c;
}

.error-message {
  color: #e74c3c;
  font-size: 12px;
  margin-top: -4px;
}

.form-hint {
  font-size: 12px;
  color: #999;
  margin: 0;
}

.user-type-description {
  font-size: 12px;
  color: #666;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 6px;
  margin-top: 4px;
}

/* Card Section */
.card-section {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 8px;
}

.card-section-header {
  background: #f9f9f9;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
}

.card-section-header:hover {
  background: #f0f0f0;
}

.card-section-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.expand-icon {
  font-size: 20px;
  color: #666;
  font-weight: 300;
}

.card-form {
  padding: 20px;
  background: white;
}

.card-preview {
  margin-bottom: 24px;
}

.card-visual {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  border-radius: 12px;
  padding: 20px;
  height: 180px;
  color: white;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-chip {
  width: 40px;
  height: 30px;
  background: linear-gradient(135deg, #f4d03f 0%, #f39c12 100%);
  border-radius: 6px;
  position: relative;
}

.card-chip::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 2px;
  background: rgba(0, 0, 0, 0.3);
}

.card-number-display {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
  font-family: 'Courier New', monospace;
  margin: 20px 0;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.card-holder-display {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.card-expiry-display {
  font-size: 12px;
  letter-spacing: 1px;
}

.card-logo {
  position: absolute;
  bottom: 20px;
  right: 20px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  opacity: 0.9;
}

.form-row {
  display: flex;
  gap: 16px;
}

.form-row-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.login-button {
  margin-top: 8px;
  padding: 14px 24px;
  background: linear-gradient(135deg, #F01714 0%, #F01714 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  font-family: inherit;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(240, 23, 20, 0.4);
}

.login-button:active {
  transform: translateY(0);
}

/* Responsive */
@media (max-width: 600px) {
  .login-container {
    padding: 24px;
  }

  .login-header h1 {
    font-size: 24px;
  }

  .form-row-split {
    grid-template-columns: 1fr;
  }
}

/* Disclaimer Footer */
.disclaimer-footer {
  margin-top: 32px;
  padding: 20px;
  background: #f9f9f9;
  border-left: 4px solid #F01714;
  border-radius: 8px;
  font-size: 12px;
  color: #555;
  line-height: 1.6;
}

.disclaimer-footer h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 700;
  color: #333;
}

.disclaimer-footer p {
  margin: 8px 0;
}

.disclaimer-footer ul {
  margin: 8px 0;
  padding-left: 24px;
}

.disclaimer-footer li {
  margin: 6px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,uGAAuG;EACvG,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;EAC1E,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".login-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n}\n\n/* Override body overflow when login page is shown */\nbody.login-page-active {\n  overflow: auto !important;\n}\n\n.login-container {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 500px;\n  padding: 40px;\n  margin: 40px auto;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.dbs-logo {\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: center;\n}\n\n.login-header h1 {\n  font-size: 28px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.login-subtitle {\n  color: #666;\n  font-size: 14px;\n  margin: 0;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.form-group input,\n.form-group select {\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: border-color 0.2s;\n  background: white;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #F01714;\n}\n\n.form-group input.error,\n.form-group select.error {\n  border-color: #e74c3c;\n}\n\n.error-message {\n  color: #e74c3c;\n  font-size: 12px;\n  margin-top: -4px;\n}\n\n.form-hint {\n  font-size: 12px;\n  color: #999;\n  margin: 0;\n}\n\n.user-type-description {\n  font-size: 12px;\n  color: #666;\n  padding: 8px 12px;\n  background: #f5f5f5;\n  border-radius: 6px;\n  margin-top: 4px;\n}\n\n/* Card Section */\n.card-section {\n  border: 2px solid #e0e0e0;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-top: 8px;\n}\n\n.card-section-header {\n  background: #f9f9f9;\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.card-section-header:hover {\n  background: #f0f0f0;\n}\n\n.card-section-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n}\n\n.expand-icon {\n  font-size: 20px;\n  color: #666;\n  font-weight: 300;\n}\n\n.card-form {\n  padding: 20px;\n  background: white;\n}\n\n.card-preview {\n  margin-bottom: 24px;\n}\n\n.card-visual {\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);\n  border-radius: 12px;\n  padding: 20px;\n  height: 180px;\n  color: white;\n  position: relative;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.card-chip {\n  width: 40px;\n  height: 30px;\n  background: linear-gradient(135deg, #f4d03f 0%, #f39c12 100%);\n  border-radius: 6px;\n  position: relative;\n}\n\n.card-chip::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 20px;\n  height: 2px;\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.card-number-display {\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  font-family: 'Courier New', monospace;\n  margin: 20px 0;\n}\n\n.card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.card-holder-display {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.card-expiry-display {\n  font-size: 12px;\n  letter-spacing: 1px;\n}\n\n.card-logo {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  opacity: 0.9;\n}\n\n.form-row {\n  display: flex;\n  gap: 16px;\n}\n\n.form-row-split {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n\n.login-button {\n  margin-top: 8px;\n  padding: 14px 24px;\n  background: linear-gradient(135deg, #F01714 0%, #F01714 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  font-family: inherit;\n}\n\n.login-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(240, 23, 20, 0.4);\n}\n\n.login-button:active {\n  transform: translateY(0);\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .login-container {\n    padding: 24px;\n  }\n\n  .login-header h1 {\n    font-size: 24px;\n  }\n\n  .form-row-split {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Disclaimer Footer */\n.disclaimer-footer {\n  margin-top: 32px;\n  padding: 20px;\n  background: #f9f9f9;\n  border-left: 4px solid #F01714;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #555;\n  line-height: 1.6;\n}\n\n.disclaimer-footer h4 {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #333;\n}\n\n.disclaimer-footer p {\n  margin: 8px 0;\n}\n\n.disclaimer-footer ul {\n  margin: 8px 0;\n  padding-left: 24px;\n}\n\n.disclaimer-footer li {\n  margin: 6px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
